export const AuthCopy = {
  'issuer-tooltip':
    'You can do this any time after sign up. Selecting this option will allow you to create an issuer entity and subsequently create tokens and faucets',
};
